import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAuditLogs } from '../../../store/actions/auditLogsActions'
import { tableHeadersFields, transactionTimeStamp } from '../../../utils'
import Filters from '../../../components/elements/Filters'
import Loader from '../../../components/elements/Loader'
import DataTable from '../../../components/elements/DataTable'
import EmptyState from '../../../components/elements/EmptyState'
import AuditLogActionType from '../../../components/elements/AuditLogActionType'

const AuditLogs = () => {
  const dispatch = useDispatch()
  const auditLogsSelector = useSelector((state => state.auditLogs))
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [filters, setFilters] = useState('');

  useEffect(() => {
    dispatch(fetchAuditLogs(filters, page, perPage))

    return () => {
      
    };
  }, [page, perPage, dispatch, filters]);

  const tableOptions = {
    selectable: false,
    multiselect: false,
    clickableRows: true,
    rowAction: (rowIndex)=>{
      // navigate(`role/${rolesSelector.roles?.roles[rowIndex]._id}`)
    }
  }

  const columnWidths = {
    actionType: 'w-2/12',
    description: 'w-4/12',
    actor: 'w-3/12',
    dateCreated: 'w-3/12',
  }

  const columnDataStyles = {}

  const cleanUpTableData = (array) => {
    if(!array) return
    let finalResult = [] 
    array.forEach((object, objectIndex) => {
        const applicationObject = {
          actionType: <AuditLogActionType type={object.actionType} />,
          description: object.description,
          actor: <p>{object?.actor?.name}</p>,
          dateCreated: <p>{transactionTimeStamp(object.createdAt).date} @ {transactionTimeStamp(object.createdAt).time}</p>,
        }

        finalResult.push(applicationObject)
    })
    return finalResult
  }

  return (
    <div className='w-full'>
          <div className='w-full flex justify-between'>
            <div>
              <h3 className='text-lg font-medium'>Audit Logs</h3>
              <p className='text-sm'>Audit logs keep track of all user activities on the platform. each activity by a platform user is recorded here.</p>
              <p className='text-sm text-gray-500 mt-2'>{auditLogsSelector?.auditLogs?.total || 0} audit log items</p>
            </div>

            <div>
            </div>
          </div>

          <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
            <div className='w-full'>
              {/* <Filters returnSelected={(filters)=>{setFilters(filters)}} /> */}
            </div>
          </div>

          {auditLogsSelector?.loadingAuditLogs ? 
            <Loader />
            :
            <>
              {auditLogsSelector?.auditLogs?.logs?.length > 0 ? <div className=''>
                <div className='w-full'>
                  <DataTable
                    tableHeaders={tableHeadersFields(cleanUpTableData(auditLogsSelector?.auditLogs?.logs)[0]).headers} 
                    tableData={cleanUpTableData(auditLogsSelector?.auditLogs?.logs)} 
                    columnWidths={columnWidths}
                    columnDataStyles={columnDataStyles}
                    allFields={tableHeadersFields(cleanUpTableData(auditLogsSelector?.auditLogs?.logs)[0]).fields}
                    onSelectItems={()=>{}}
                    tableOptions={tableOptions}
                    pagination={{
                        perPage, 
                        currentPage: page,
                        totalItems: auditLogsSelector?.auditLogs?.total,
                    }}
                    onSelectSingle={()=>{}}
                    changePage={(page)=>setPage(page)}
                    updatePerPage={(perPage)=>{setPerPage(perPage)}}
                  />
                </div>
              </div>
                : 
                <div className='mt-24 w-1/2 mx-auto'>
                  <EmptyState emptyStateText={`There are no audit logs yet! When platform users start working, all actions will be recorded here`} />
                </div>

              }
            </>
          }
        </div>
  )
}

export default AuditLogs